import React from "react";
import {
  ActionCell,
  CustomTable,
  TableBody,
  TableCell,
  TableContainer,
  TableHeader,
  TableRow,
} from "./StyledTable";
import Skeleton from "react-loading-skeleton";
import { getRandomNumber } from "../../utils/helper";

const StyledTableSkeleton = () => {
  return (
    <TableContainer>
      <CustomTable>
        <TableHeader>
          {Array.from({ length: 3 }, (_, index) => (
            <TableCell key={index} className="__cell">
              <Skeleton width={getRandomNumber(50, 100)} height={18} />
            </TableCell>
          ))}
        </TableHeader>
        <TableBody>
          {Array.from({ length: 2 }, (_, headerKey) => (
            <TableRow key={headerKey}>
              {Array.from({ length: 3 }, (_, index) => (
                <TableCell
                  className="d-none d-md-block"
                  key={headerKey + index}
                >
                  <Skeleton width={getRandomNumber(100, 140)} height={16} />
                </TableCell>
              ))}
              <div className="d-flex flex-column d-md-none _two-items">
                {Array.from({ length: getRandomNumber(2, 3) }, (_, index) => (
                  <TableCell key={index}>
                    <span className="d-flex align-items-center gap-2">
                      <Skeleton width={getRandomNumber(50, 150)} height={16} />
                    </span>
                  </TableCell>
                ))}
              </div>
              <ActionCell className="d-flex d-md-none">
                <Skeleton width={40} height={16} />
              </ActionCell>
            </TableRow>
          ))}
        </TableBody>
      </CustomTable>
    </TableContainer>
  );
};

export default StyledTableSkeleton;
